import { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import queryString from 'query-string';
import moment from 'moment-timezone';
import useNetwork from '@/hooks/useNetwork';
import { project_networkId } from '@/utils/query-helpers';
import getQueryUtils, { attributeKeys } from '@/pages/evaluations-project-partners/queryUtils';

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 10,
    schoolStart,
    schoolEnd
  } = props;

  const [timestamp] = useState(moment().toISOString());
  const network = useNetwork();

  const queryUtils = getQueryUtils(search, attributeKeys, timestamp);

  return useConnect('evaluationProjectPartner.find', {
    where: {
      eager: {
        $where: {
          $and: [...queryUtils.where],
          ...project_networkId(network),
          completed: false,
          status: { $ne: 'abandoned' },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc'
    }
  }, {
    keepPreviousData: true
  });
}
